import React from "react";
import { useIntl, defineMessages } from "react-intl";

import premiumIcon from "@/assets/icons/premium.svg";
import { Icon } from "@/components/ui";
import { cn } from "@/utils/cn";

const messages = defineMessages({
  premium: { id: "account.premium", defaultMessage: "Truth+ Premium" },
});

interface PremiumBadgeProps {
  className?: string;
}

export default function VerificationBadge({ className }: PremiumBadgeProps) {
  const intl = useIntl();

  return (
    <span data-testid="premium-badge">
      <Icon
        className={cn("w-4 text-secondary-500", className)}
        src={premiumIcon}
        alt={intl.formatMessage(messages.premium)}
      />
    </span>
  );
}
